/**
 * Decodes HTML entities in a string to their corresponding characters.
 * This is particularly useful when rendering user-provided content
 * that may contain encoded German special characters (like umlauts: ä, ö, ü, ß)
 * @param str 
 */
export function decodeHtmlEntities(str) {
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}